"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("@emotion/react");

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _fearless = require("@zip/react-icons/fearless");

var _propTypes = require("prop-types");

var _react2 = require("react");

var css = _interopRequireWildcard(require("./NavigationDrawer.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ICON_SIZE = 20;

var DrawerItem = function DrawerItem(_ref) {
  var endAdornment = _ref.endAdornment,
      Icon = _ref.icon,
      inset = _ref.inset,
      primary = _ref.primary,
      secondary = _ref.secondary,
      props = _objectWithoutProperties(_ref, ["endAdornment", "icon", "inset", "primary", "secondary"]);

  var theme = (0, _react.useTheme)();
  return (0, _jsxRuntime.jsxs)(_ListItem["default"], _objectSpread(_objectSpread({
    css: css.drawerItem,
    alignItems: "center",
    button: true
  }, props), {}, {
    children: [Icon && (0, _jsxRuntime.jsx)(_ListItemIcon["default"], {
      css: css.drawerIcon,
      children: (0, _jsxRuntime.jsx)(Icon, {
        css: {
          height: 24,
          width: 24
        },
        fill: theme.colors.neutral[600]
      })
    }), (0, _jsxRuntime.jsx)(_ListItemText["default"], {
      inset: inset,
      css: css.drawerItemText,
      primary: primary,
      secondary: secondary
    }), endAdornment]
  }));
};

var defaultClickHandlers = {
  payments: {}
};

var NavigationDrawer = function NavigationDrawer(_ref2) {
  var onClickHandlersInput = _ref2.onClickHandlers,
      alwaysShowShopInstore = _ref2.alwaysShowShopInstore,
      props = _objectWithoutProperties(_ref2, ["onClickHandlers", "alwaysShowShopInstore"]);

  var _useState = (0, _react2.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      paymentsOpen = _useState2[0],
      setPaymentsOpen = _useState2[1];

  var onClickHandlers = _objectSpread(_objectSpread({}, defaultClickHandlers), onClickHandlersInput);

  var shouldShowPayments = onClickHandlers.payments || onClickHandlers.payments.schedule || onClickHandlers.payments.additionalPayment || onClickHandlers.payments.paymentMethods;
  return (0, _jsxRuntime.jsx)(_Drawer["default"], _objectSpread(_objectSpread({
    ModalProps: {
      BackdropProps: {
        invisible: true
      }
    },
    PaperProps: {
      component: 'nav'
    }
  }, props), {}, {
    children: (0, _jsxRuntime.jsxs)(_List["default"], {
      css: css.list,
      disablePadding: true,
      children: [onClickHandlers.walletOverview && (0, _jsxRuntime.jsx)(DrawerItem, {
        icon: _fearless.Wallet,
        primary: "Wallet overview",
        onClick: onClickHandlers.walletOverview,
        id: "data-e2e-overview",
        "data-e2e": "overview"
      }), onClickHandlers.personalDetails && (0, _jsxRuntime.jsx)(DrawerItem, {
        icon: _fearless.UserSquare,
        primary: "Personal details",
        onClick: onClickHandlers.personalDetails,
        id: "data-e2e-personal-details",
        "data-e2e": "personal-details"
      }), shouldShowPayments && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [(0, _jsxRuntime.jsx)(DrawerItem, {
          endAdornment: paymentsOpen ? (0, _jsxRuntime.jsx)(_fearless.ChevronUp, {
            size: ICON_SIZE
          }) : (0, _jsxRuntime.jsx)(_fearless.ChevronDown, {
            size: ICON_SIZE
          }),
          icon: _fearless.CurrencyDollarCircle,
          primary: "Payments",
          id: "data-e2e-payments",
          "data-e2e": "payments",
          onClick: function onClick() {
            return setPaymentsOpen(!paymentsOpen);
          }
        }), (0, _jsxRuntime.jsx)(_Collapse["default"], {
          "in": paymentsOpen,
          timeout: "auto",
          unmountOnExit: true,
          children: (0, _jsxRuntime.jsxs)(_List["default"], {
            disablePadding: true,
            children: [onClickHandlers.payments.schedule && (0, _jsxRuntime.jsx)(DrawerItem, {
              inset: true,
              primary: "Schedule",
              id: "data-e2e-schedule",
              "data-e2e": "schedule",
              onClick: onClickHandlers.payments.schedule
            }), onClickHandlers.payments.additionalPayment && (0, _jsxRuntime.jsx)(DrawerItem, {
              inset: true,
              primary: "Additional payment",
              id: "data-e2e-additional-payment",
              "data-e2e": "additional-payment",
              onClick: onClickHandlers.payments.additionalPayment
            }), onClickHandlers.payments.paymentMethods && (0, _jsxRuntime.jsx)(DrawerItem, {
              inset: true,
              primary: "Payment methods",
              id: "data-e2e-payment-methods",
              "data-e2e": "payment-methods",
              onClick: onClickHandlers.payments.paymentMethods
            })]
          })
        })]
      }), onClickHandlers.bills && (0, _jsxRuntime.jsx)(DrawerItem, {
        icon: _fearless.Bill,
        primary: "Pay bills with Zip",
        id: "data-e2e-bills",
        "data-e2e": "bills",
        onClick: onClickHandlers.bills
      }), onClickHandlers.subscriptions && (0, _jsxRuntime.jsx)(DrawerItem, {
        icon: _fearless.Calendar,
        primary: "Pay subscriptions",
        id: "data-e2e-subscriptions",
        "data-e2e": "subscriptions",
        onClick: onClickHandlers.subscriptions
      }), onClickHandlers.invoices && (0, _jsxRuntime.jsx)(DrawerItem, {
        icon: _fearless.Bill,
        primary: "Pay invoices with Zip",
        id: "data-e2e-invoices",
        "data-e2e": "invoices",
        onClick: onClickHandlers.invoices
      }), onClickHandlers.recentActivity && (0, _jsxRuntime.jsx)(DrawerItem, {
        icon: _fearless.Receipt,
        primary: "Recent activity",
        id: "data-e2e-recent-activity",
        "data-e2e": "recent-activity",
        onClick: onClickHandlers.recentActivity
      }), onClickHandlers.limitIncrease && (0, _jsxRuntime.jsx)(DrawerItem, {
        icon: _fearless.ArrowUp,
        primary: "Limit increase",
        id: "data-e2e-limit-increase",
        "data-e2e": "limit-increase",
        onClick: onClickHandlers.limitIncrease
      }), onClickHandlers.statements && (0, _jsxRuntime.jsx)(DrawerItem, {
        icon: _fearless.Statement,
        primary: "Statements",
        id: "data-e2e-statements",
        "data-e2e": "statements",
        onClick: onClickHandlers.statements
      }), onClickHandlers.shopDirectory && (0, _jsxRuntime.jsx)(DrawerItem, {
        icon: _fearless.Shop,
        primary: "Shop directory",
        id: "data-e2e-shop-directory",
        "data-e2e": "shop-directory",
        onClick: onClickHandlers.shopDirectory
      }), onClickHandlers.shopInstore && (0, _jsxRuntime.jsx)(DrawerItem, {
        css: css.shopInstore(alwaysShowShopInstore),
        icon: _fearless.ScanBarcode,
        primary: "Shop instore",
        onClick: onClickHandlers.shopInstore
      }), onClickHandlers.help && (0, _jsxRuntime.jsx)(DrawerItem, {
        icon: _fearless.InformationCircle,
        primary: "Help/FAQs",
        id: "data-e2e-help",
        "data-e2e": "help",
        onClick: onClickHandlers.help
      }), onClickHandlers.help && (0, _jsxRuntime.jsx)(DrawerItem, {
        icon: _fearless.ArrowLeft,
        primary: "Back to accounts",
        id: "data-e2e-back",
        "data-e2e": "back",
        onClick: onClickHandlers.back
      }), onClickHandlers.logout && (0, _jsxRuntime.jsx)(DrawerItem, {
        primary: "Log out",
        onClick: onClickHandlers.logout,
        id: "data-e2e-logout",
        "data-e2e": "logout"
      })]
    })
  }));
};

NavigationDrawer.propTypes = {
  /**
   * Side from which the drawer will appear.
   */
  anchor: (0, _propTypes.oneOf)(['left', 'top', 'right', 'bottom']),

  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: _propTypes.func,

  /**
   * If `true`, the drawer is open.
   */
  open: _propTypes.bool,

  /**
   * The variant to use.
   */
  variant: (0, _propTypes.oneOf)(['permanent', 'persistent', 'temporary']),

  /**
   * An onclick callback for each of the menu items
   */
  onClickHandlers: (0, _propTypes.shape)({
    walletOverview: _propTypes.func,
    personalDetails: _propTypes.func,
    payments: (0, _propTypes.oneOfType)([_propTypes.func, (0, _propTypes.shape)({
      schedule: _propTypes.func,
      additionalPayment: _propTypes.func,
      paymentMethods: _propTypes.func
    })]),
    bills: _propTypes.func,
    subscriptions: _propTypes.func,
    recentActivity: _propTypes.func,
    limitIncrease: _propTypes.func,
    shopDirectory: _propTypes.func,
    shopInstore: _propTypes.func,
    statements: _propTypes.func,
    help: _propTypes.func,
    back: _propTypes.func,
    logout: _propTypes.func,
    invoices: _propTypes.func
  }),

  /**
   * Default behaviour is only show "Shop Instore" menu if on mobile
   * If `true`, always show "Show Instore".
   */
  alwaysShowShopInstore: _propTypes.bool
};
NavigationDrawer.defaultProps = {
  anchor: 'left',
  onClose: undefined,
  open: false,
  variant: 'temporary',
  onClickHandlers: defaultClickHandlers,
  alwaysShowShopInstore: false
};
DrawerItem.propTypes = {
  /**
   * Element placed to the right of the text
   */
  endAdornment: _propTypes.node,
  icon: _propTypes.elementType,

  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: _propTypes.bool,

  /**
   * The main content element.
   */
  primary: _propTypes.node,

  /**
   * The secondary content element.
   */
  secondary: _propTypes.node,

  /**
   * Use to apply selected styling.
   */
  selected: _propTypes.bool
};
DrawerItem.defaultProps = {
  endAdornment: undefined,
  primary: undefined,
  secondary: undefined,
  icon: undefined,
  inset: false,
  selected: false
};
var _default = NavigationDrawer;
exports["default"] = _default;